export default __webpack_public_path__ + "static/media/Apple-wallet.91ad90a5.png";